import { z } from 'zod'

export const UpdatePeselPayloadSchema = z.object({
  childEditionId: z.number().or(z.string()),
  pesel: z.string().nullish()
})

export const FetchPeselPayloadSchema = z.object({
  childEditionId: z.number().or(z.string())
})
